export class Beneficiario{
    baja?:string
    contrato?:string
    direccion?:string
    documento?:string
    edad?:string
    estado?:string
    estadoBen?:string
    fechaIngreso?:string
    fechaRetiro?:string
    nombre?:string
    nombreContrato?:string
    telefono?:string
    tiempoDisponible?:number
    tipoContrato?:string
    estadoCod?:number
    ID_Ben?:string
    prioridad?:string
}
import { Component, OnInit} from '@angular/core';
import { BeneficiariosService } from '../../services/beneficiarios.service';
import { Service } from '../../entities/servicios-backend';
import { Observable, of } from 'rxjs';
import { ServiciosService } from '../../services/servicios.service';
import { MatDialog } from '@angular/material';
import { UsuariosApComponent } from '../usuarios-ap/usuarios-ap.component';
import swal from 'sweetalert2';
import { MatDialogRef } from '@angular/material'
import { HttpErrorResponse } from '@angular/common/http'
import { AlertService } from 'ngx-alerts'
@Component({
  selector: 'app-agregar-consulta-paciente',
  templateUrl: './agregar-consulta-paciente.component.html',
  styleUrls: ['./agregar-consulta-paciente.component.scss']
})
export class AgregarConsultaPacienteComponent implements OnInit {
    public opciones;
    public search:boolean;
    public beneficiarios:Array<Beneficiario>;
    public currentPageBen;
    public currentPageSer;
    public busqueda;
    public selectedBeneficiario:Beneficiario;
    public servicios$:Array<Service>;
    constructor(private _beneficiarios: BeneficiariosService,
                private _servicios: ServiciosService,
                private _dialogRef: MatDialogRef<AgregarConsultaPacienteComponent>,
                private dialog: MatDialog,
                private _alert:AlertService){
        this.selectedBeneficiario = new Beneficiario();
        this.currentPageSer = 1;
        this.search = false;
        this.opciones = {
            edad:'',
            tipoContrato:'',
            contrato:'',
            nombre:'',
            documento:'',
            direccion:'',
            telefono:''
        }
    }

    ngOnInit() {
        this.servicios$ = [];
        this.beneficiarios = [];
    }
    buscarBeneficiarios(){
        var busqueda;
        this.currentPageBen = 1;
        var campo;
        for(let opcion in this.opciones){
            if(this.opciones[opcion] != null && this.opciones[opcion] != undefined && this.opciones[opcion] != ''  ){
                busqueda = this.opciones[opcion];
                campo = opcion;
                break;
            }
        }
        this.search = true;
        this._beneficiarios.beneficiarios(busqueda,campo).subscribe((succ:Array<Beneficiario>)=>{
            console.log(succ.length)
            if(succ.length === 0){
                console.log(this._alert.danger('hola'));
            }
            this.beneficiarios = succ;
            this.search = false;
        })
    }

    selectBen(beneficiario:Beneficiario){
        if(beneficiario == this.selectedBeneficiario) return;
        this.selectedBeneficiario = beneficiario;
        this._servicios.totalServicios<Array<Service>>(beneficiario.documento).subscribe(succ=>{
            console.log(succ.length)
            if(succ.length === 0){
                this._alert.danger('No encontramos ningún beneficiario con estas especificaciones')
            }
            this.servicios$ = succ;
        },this.error);
    }

    addService(beneficiario:Beneficiario){
        if( (beneficiario.tiempoDisponible < 0) && ( beneficiario.estadoCod != 15 && beneficiario.estadoCod != 0 ) ) {
            let v = 2;
            return swal.fire({
                title:'Error!',
                type:'error',
                text : "No puedes agregar un servicios de un usuario que no esté activo y su contrato no esté vigente",
                timer:1500,
                showConfirmButton:false
            });

        }
        this._dialogRef.close();
        this._servicios.addService(beneficiario);
    }

    usuariosap(beneficiario:Beneficiario){
        this.dialog.open(UsuariosApComponent,{
            width:'99%',
            height:'90%',
            data:{
                matricula:beneficiario.documento
            }
        })
    }
    public error(e:HttpErrorResponse){
        console.log(e);
    }
}
